import axiosClient from "./axiosClient";

export const obtenerGrid = () => axiosClient.get("/familia-gastos/grid").then((r) => r.data);
// usuarioId: solo hace falta cuando el Jefe edita el aporte/sueldo de OTRO miembro; para el propio
// se puede omitir (el backend asume "el que llama" cuando viene null).
export const registrarAporte = (gastoComunId, monto, usuarioId) =>
  axiosClient.post("/familia-gastos/aportes", { gastoComunId, monto, usuarioId }).then((r) => r.data);
export const registrarSueldo = (monto, usuarioId) =>
  axiosClient.post("/familia-gastos/sueldo", { monto, usuarioId }).then((r) => r.data);

export const guardarAjuste = (ajuste) =>
  axiosClient.post("/familia-gastos/ajustes", ajuste).then((r) => r.data);
export const eliminarAjuste = (ajusteId) =>
  axiosClient.delete(`/familia-gastos/ajustes/${ajusteId}`).then((r) => r.data);
export const guardarOrdenAjustes = (ajusteIds) =>
  axiosClient.post("/familia-gastos/ajustes/orden", { ajusteIds }).then((r) => r.data);
